import React from 'react';
export var ItemCartContext = /*#__PURE__*/React.createContext({
  apiErrorMessage: '',
  formErrors: {},
  loading: false,
  item: {},
  modifierLists: [],
  modifiers: [],
  variations: [],
  selectedModifiers: [],
  selectedVariation: '',
  quantity: 1,
  specialInstructions: '',
  setFormError: function setFormError() {},
  toggleSelectedModifier: function toggleSelectedModifier() {},
  setSelectedVariation: function setSelectedVariation() {},
  setQuantity: function setQuantity() {},
  setSpecialInstructions: function setSpecialInstructions() {}
});
export var ItemCartProvider = ItemCartContext.Provider;